import {
    FIELD_OPTION,
    FIELD_OPTION_ERROR,
} from '../constants/actions';

const initialState = {
    error: '',
    options: {},
};

export default function fundingSrcReducer(state = initialState, action) {
    switch (action.type) {
        case FIELD_OPTION:
        return {...state,
            error: '',
            [action.payload.field]: action.payload.options,
        };

        case FIELD_OPTION_ERROR:
        return {...state,
            error: action.payload.error,
        };

        default:
        return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/options.js